import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { QuoteCodeService } from 'app/services/models/quote-code.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-customer-confirm-code',
  templateUrl: './customer-confirm-code.component.html',
  styleUrls: ['./customer-confirm-code.component.scss']
})
export class CustomerConfirmCodeComponent implements OnInit {
  @Input() customerId: number;
  customerConfirmMailForm: FormGroup;

  constructor(public activeModal: NgbActiveModal,
    private toastrService: ToastrService,
    private fb: FormBuilder,
    private quoteCode: QuoteCodeService) { }

  ngOnInit() {
    this.customerConfirmMailForm = this.fb.group({
      code: [null, Validators.required],
    });
  }

  async sendEmail() {
    const data = await this.quoteCode.quoteCodeConfirmed(this.customerConfirmMailForm.value.code, this.customerId);
    if(data.status){
      this.toastrService.success(data.message);
      this.closeModal(true);
    }else{
      this.toastrService.error(data.message);
      this.closeModal(false);
    }
  }

  closeModal(result:boolean = false){
    this.activeModal.close(result);
  }
}
